import { Stack, Tooltip, Typography } from '@mui/material';
import { useTenantFlagsToggleTooltipStyles } from './TenantCardSummaryStyles';
import OverflowTooltip from 'common/custom-components/lib/components/OverflowTooltip';
import { TenantFlagToggle } from './TenantFlagToggle';
import { useMemo } from 'react';

interface TenantFlagToggleTooltipProps {
  flags: any[];
  onToggle: (flag: any) => void;
}

const TenantFlagToggleTooltip = (props: TenantFlagToggleTooltipProps) => {
  const { flags = [], onToggle } = props;
  const classes = useTenantFlagsToggleTooltipStyles();

  const tenantFlags = useMemo(
    () => flags?.filter((data) => !!data) || [],
    [flags],
  );

  return (
    <Tooltip
      title={
        <Stack sx={classes.tooltipContainer}>
          {tenantFlags?.map((flag, _id) => (
            <Stack sx={classes.flagContainer}>
              <OverflowTooltip
                text={`${flag?.displayName || flag?.name} :`}
                sxClass={classes.flagLabel}
              />
              <TenantFlagToggle
                checked={flag.value}
                onChange={() => onToggle(flag)}
              />
            </Stack>
          ))}
        </Stack>
      }
      arrow
      PopperProps={classes.tooltipPopper}
    >
      {Boolean(flags?.length) && (
        <Typography sx={classes.noOfFlagsText}>{flags?.length}</Typography>
      )}
    </Tooltip>
  );
};

export default TenantFlagToggleTooltip;
